"use client";
import { ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export default function QueryProvider({ children }: { children: ReactNode }) {
  // Create the client only once per browser tab with optimized config to reduce excessive refetching
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Reduce aggressive refetching to prevent performance issues
            refetchOnWindowFocus: false, // Disable automatic refetch on focus
            refetchOnMount: true, // Refetch only if data is stale (respects staleTime)
            refetchOnReconnect: true, // Keep this for network reconnection
            // Increase stale time to reduce unnecessary refetches
            staleTime: 1000 * 60 * 5, // Data is considered stale after 5 minutes
            // Reduce retry attempts to prevent excessive requests
            retry: 2,
            retryDelay: attemptIndex =>
              Math.min(1000 * 2 ** attemptIndex, 10000), // Max 10s delay
            // Add gcTime to prevent memory leaks
            gcTime: 1000 * 60 * 10, // 10 minutes
          },
          mutations: {
            retry: 1, // Reduce mutation retries
            retryDelay: 1000,
          },
        },
      })
  );
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
